import { batch, signal } from "@preact/signals-react"


export const retailers = signal([])
export const items = signal([])
export const counts = signal({})
// Count of VtResource rows where needs_qa=true within the current
// retailer/country scope (date-agnostic — resources are retailer-wide).
// Powers the "N resources pending QA" chip in the Pipeline header.
export const resourcesNeedsQa = signal(0)

export const selectedDate = signal(new Date().toISOString().slice(0, 10))
export const selectedRetailerId = signal(null)
export const selectedStage = signal(null)
export const selectedCountry = signal('')
// 'web' | 'newsletter' | '' (all). Client-side list filter and also
// propagated to the bulk re-export endpoints so the admin can scope
// e.g. "re-export every newsletter on this date" without manually
// picking sections.
export const selectedSectionKind = signal('')
// Client-side list filter: only tasks whose export chip is red (a client
// carries `last_error` — failed upload or failed ACK to the consumer).
export const exportFailingOnly = signal(false)

export const isLoading = signal(false)
export const busyTaskIds = signal(new Set())   // tasks with an in-flight rescore/retry

export const clearPipelineSignals = () => batch(() => {
	retailers.value = []
	items.value = []
	counts.value = {}
	resourcesNeedsQa.value = 0
	selectedDate.value = new Date().toISOString().slice(0, 10)
	selectedRetailerId.value = null
	selectedStage.value = null
	selectedCountry.value = ''
	selectedSectionKind.value = ''
	exportFailingOnly.value = false
	isLoading.value = false
	busyTaskIds.value = new Set()
})
